<template>
  <v-dialog v-model="dialog" persistent width="600">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-flex xs9>
          <v-icon>{{ form.id ? "edit" : "add" }}</v-icon>
          {{ "Revisar/Observar" }}
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn icon @click.native="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex md12> <b> Nombre completo:</b> {{ form.nombre }} </v-flex>
              <v-flex md12> <b>Item: </b> {{ form.item }} </v-flex>

              <v-flex md12>
                <v-textarea
                  label="Observación"
                  v-model="form.observacion"
                  maxlength="250"
                ></v-textarea>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <small class="error--text text-required"
            >* Los campos son obligatorios</small
          >
          <v-spacer></v-spacer>

          <v-btn
            color="success"
            :loading="loading"
            @click.native="save(38)"
            :disabled="!valid"
          >
            Revisar
          </v-btn>
          <v-btn
            dark
            color="red"
            @click.native="save(40)"
            :loading="loading"
            :disabled="!valid"
          >
            Observar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      form: {},
      valid: false,
      loading: false,
    };
  },
  mounted() {
    this.$bus.$on("openDialogRevisarObservarListaFicha", (item) => {
      this.form = item;
      this.dialog = true;
    });
  },
  methods: {
    close() {
      (this.form = {}), (this.loading = false);
      // this.valid = false
      this.$bus.$emit("closeDialog");
      this.dialog = false;
    },
    async sendMessage() {
      let correo = await this.getMail();
      try {
        let body = {
          mail: correo,
          asunto: "Observación ficha personal",
          message: this.form.observacion,
        };

        const token = this.$storage.get("token");
        const url = process.env.API_URL + "system/sendmail";

        const options = {
          method: "POST",
          headers: {
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        };

        var data = await fetch(url, options);
        data = await data.json();
        if (data.mensaje == "Success") {
          this.$message.success("Se envio el correo");
        } else {
          this.$message.error(data.mensaje);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getMail() {
      try {
        let res = await this.$service.graphql({
          query: `
			query{
				persona(id: ${this.form.id_persona}){
					usuarios{
						correo
					}
				}
				}
				`,
        });
        return res.persona.usuarios[0].correo;
      } catch (err) {
        console.log(err);
      }
    },
    async save(id_nuevo_estado) {
      let resp = 0;
      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
		if (id_nuevo_estado == 40) {
            if (this.form.observacion == null || this.form.observacion=="") {
              this.$message.error("Debe incluir una observación");
              this.loading = false;
              return;
            } else {
              this.sendMessage();
            }
          } 
		  const user = this.$storage.get("user");
          let respuesta = await this.$service.graphql({
            query: `
							query{
							runQuery(consulta:"select persona.fn_estadoficha(${this.form.id_persona}, ${user.id},${id_nuevo_estado},'${this.form.observacion}')"){
								respuesta
							}
							}
						`,
          });
          resp = respuesta.runQuery.respuesta[0].fn_estadoficha;
        } catch (error) {
          console.log(error);
        }
        if (resp == 1) {
          this.$message.success();
        } else {
          this.$message.error();
        }
        this.loading = false;
        this.close();
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/admin/v_listaficha/dialogs/RevisarObservarListaFicha.vue